import * as React from 'react';

export const GoogleIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.455 11.2385C21.455 10.494 21.3882 9.77809 21.2641 9.09082H11.375V13.1524H17.0259C16.7825 14.4649 16.0427 15.577 14.9307 16.3215V18.9561H18.3241C20.3095 17.1281 21.455 14.4363 21.455 11.2385Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3754 21.5001C14.2104 21.5001 16.5872 20.5599 18.3245 18.9563L14.9311 16.3217C13.9908 16.9517 12.7881 17.324 11.3754 17.324C8.6406 17.324 6.32583 15.4769 5.50014 12.9951H1.99219V15.7156C3.71992 19.1472 7.27083 21.5001 11.3754 21.5001Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49977 12.9946C5.28977 12.3646 5.17046 11.6917 5.17046 10.9996C5.17046 10.3076 5.28977 9.63464 5.49977 9.00464V6.28418H1.99182C1.28068 7.70168 0.875 9.30532 0.875 10.9996C0.875 12.694 1.28068 14.2976 1.99182 15.7151L5.49977 12.9946Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3754 4.67614C12.917 4.67614 14.3011 5.20591 15.3892 6.24637L18.4008 3.23477C16.5824 1.54046 14.2056 0.5 11.3754 0.5C7.27083 0.5 3.71992 2.85296 1.99219 6.28455L5.50014 9.005C6.32583 6.52319 8.6406 4.67614 11.3754 4.67614Z"
        fill="#EA4335"
      />
    </svg>
  );
};
